import { FC } from "react";
import { cn } from "@edusogno/lib/utils";

// Non-reusable --- collocate with component
type NoItemProps = {
  text: string;
  className?: string;
};

const NoItem: FC<NoItemProps> = ({ text, className }) => (
  <div
    className={cn(
      "flex flex-row text-center h-[60px] lg:h-[65px] bg-[--grey100] mt-4 w-full justify-center items-center text-brand-deep gap-2 p-3 bg-white rounded-md",
      className,
    )}
  >
    {text}
  </div>
);

export default NoItem;
